import { Data } from "app/app-web/app-model/utils/dto/data.model";

export class AppointmentEnum {

    public static readonly NONE: Data = { id: 1, name: "lblNot" };
    public static readonly FIXED_DATE: Data = { id: 2, name: "lblFixDate" };
    public static readonly INTERVAL_DATE: Data = { id: 3, name: "lblDateInterval" };
    public static readonly MAX_DATE: Data = { id: 4, name: "lblMaxDate" };
    public static readonly OVERT_DATE: Data = { id: 5, name: "lblOvertDate" };


	public static getAppointmentList() {
		return [AppointmentEnum.NONE, AppointmentEnum.FIXED_DATE, AppointmentEnum.INTERVAL_DATE,
		AppointmentEnum.MAX_DATE, AppointmentEnum.OVERT_DATE];
	}

}
